import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorService } from './error.service';
import { HttpMethod } from './http-method.enum';

export function handleError<T>(
    operation: string,
    errorService: ErrorService,
    resourceTypeName: string
): (error: Error) => Observable<T> {
    return (error: Error): Observable<T> => {
        console.error(`${operation} failed: ${error.message}`);
        return errorService.handleError<T>(`${operation} ${resourceTypeName}`)(error);
    };
}

/** Query parameters of a list query; unset and empty values are left out. */
export function toHttpParams(query: object): HttpParams {
    return Object.entries(query).reduce((params: HttpParams, [key, value]) => {
        if (value === null || value === undefined || value === '') {
            return params;
        }
        return params.set(key, String(value));
    }, new HttpParams());
}

export function makeRequest<T>(
    _httpClient: HttpClient,
    method: HttpMethod,
    url: string,
    options: {
        body?: unknown;
        params?: HttpParams | { [param: string]: string | string[] };
        headers?: HttpHeaders | { [header: string]: string | string[] };
        observe?: 'body' | 'response';
        responseType?: 'json' | 'text' | 'blob' | 'arraybuffer';
    } = {},
    errorHandler: (error: Error) => Observable<T>
): Observable<T> {
    return _httpClient
        .request(method, url, {
            body: options.body,
            params: options.params,
            headers: options.headers,
            observe: options.observe || 'body',
            responseType: options.responseType || 'json'
        })
        .pipe(catchError(errorHandler));
}
